import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import TrustedMarinePerformanceHero from "./sections/TrustedMarinePerformanceHero";
import TheAlttaiStandard from "./sections/TheAlttaiStandard";
import MarinePartCategories from "./sections/MarinePartCategories";
import FeaturedOemComponents from "./sections/FeaturedOemComponents";
import IndustrialExcellenceFeatures from "./sections/IndustrialExcellenceFeatures";
import DirectInquiry from "./sections/DirectInquiry";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <TrustedMarinePerformanceHero />
      <TheAlttaiStandard />
      <MarinePartCategories />
      <FeaturedOemComponents />
      <IndustrialExcellenceFeatures />
      <DirectInquiry />
      <Footer />
    </div>;
}